import { render, staticRenderFns } from "./Termo.vue?vue&type=template&id=12d5548e"
import script from "./Termo.vue?vue&type=script&lang=js"
export * from "./Termo.vue?vue&type=script&lang=js"
import style0 from "./Termo.vue?vue&type=style&index=0&id=12d5548e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports